/**
 * Header — Functional Medicine
 * Vanilla JS, no dependencies. Progressive enhancement:
 * desktop dropdowns already work via CSS :hover/:focus-within
 * without this file; this adds click-to-toggle (for touch/keyboard
 * button semantics), the mobile drawer, and sticky/transparent scroll state.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-fmh]').forEach(function (root) {
    var burger = root.querySelector('[data-fmh-burger]');
    var drawer = root.querySelector('[data-fmh-drawer]');
    var overlay = root.querySelector('[data-fmh-overlay]');
    var closeBtn = root.querySelector('[data-fmh-close]');
    var html = document.documentElement;

    /* ---------------- Mobile drawer ---------------- */
    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('fmh-open');
      overlay.classList.add('fmh-visible');
      html.classList.add('fmh-lock');
      burger.setAttribute('aria-expanded', 'true');
      var firstFocusable = drawer.querySelector('a, button');
      if (firstFocusable) firstFocusable.focus();
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('fmh-open');
      overlay.classList.remove('fmh-visible');
      html.classList.remove('fmh-lock');
      burger.setAttribute('aria-expanded', 'false');
      burger.focus();
    }

    if (burger) {
      burger.addEventListener('click', function () {
        var isOpen = drawer.classList.contains('fmh-open');
        if (isOpen) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('fmh-open')) {
        closeDrawer();
      }
    });

    /* Close the drawer if the viewport grows past the mobile breakpoint */
    var mq = window.matchMedia('(min-width: 990px)');
    function handleBreakpoint(e) {
      if (e.matches && drawer && drawer.classList.contains('fmh-open')) {
        closeDrawer();
      }
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', handleBreakpoint);
    } else if (mq.addListener) {
      mq.addListener(handleBreakpoint);
    }

    /* ---------------- Desktop dropdown positioning ----------------
       Depth-1 panels are `position: fixed` (see CSS) so they can
       escape the scrollable nav without being clipped. Being fixed
       means they need explicit left/top in JS — anchored to the
       trigger's own bounding box, not the CSS fallback. */
    var topLevelItems = root.querySelectorAll('.fmh-nav > .fmh-menu > .fmh-item[data-depth="1"].fmh-has-dropdown');

    function positionPanel(item) {
      var panel = item.querySelector(':scope > .fmh-dropdown-panel');
      if (!panel) return;
      var rect = item.getBoundingClientRect();
      panel.style.left = Math.round(rect.left) + 'px';
      panel.style.top = Math.round(rect.bottom) + 'px';
    }

    function positionOpenPanels() {
      topLevelItems.forEach(function (item) {
        var isOpenByClass = item.classList.contains('fmh-open');
        var isOpenByHover = item.matches(':hover') || item.matches(':focus-within');
        if (isOpenByClass || isOpenByHover) positionPanel(item);
      });
    }

    topLevelItems.forEach(function (item) {
      // Hover path (CSS-driven open) still needs JS-computed coordinates
      item.addEventListener('mouseenter', function () { positionPanel(item); });
      item.addEventListener('focusin', function () { positionPanel(item); });
      // Click path (keyboard/touch toggle) — position right before opening
      var toggle = item.querySelector(':scope > .fmh-dd-toggle');
      if (toggle) {
        toggle.addEventListener('click', function () { positionPanel(item); });
      }
    });

    // Recompute while any panel is open and the layout could shift
    window.addEventListener('resize', positionOpenPanels);
    window.addEventListener('scroll', positionOpenPanels, { passive: true });

    /* ---------------- Desktop dropdown toggles (click / keyboard) ---------------- */
    var desktopToggles = root.querySelectorAll('.fmh-dd-toggle');
    desktopToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = toggle.closest('.fmh-has-dropdown');
        var isOpen = item.classList.contains('fmh-open');

        // Close sibling dropdowns at the same level
        var parentList = item.parentElement;
        parentList.querySelectorAll(':scope > .fmh-has-dropdown').forEach(function (sibling) {
          if (sibling !== item) {
            sibling.classList.remove('fmh-open');
            var sibToggle = sibling.querySelector(':scope > .fmh-dd-toggle');
            if (sibToggle) sibToggle.setAttribute('aria-expanded', 'false');
          }
        });

        item.classList.toggle('fmh-open', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    // Close all open desktop dropdowns when clicking / focusing outside the nav
    document.addEventListener('click', function (e) {
      var nav = root.querySelector('.fmh-nav');
      if (nav && !nav.contains(e.target)) {
        nav.querySelectorAll('.fmh-has-dropdown.fmh-open').forEach(function (item) {
          item.classList.remove('fmh-open');
          var t = item.querySelector(':scope > .fmh-dd-toggle');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        root.querySelectorAll('.fmh-has-dropdown.fmh-open').forEach(function (item) {
          item.classList.remove('fmh-open');
          var t = item.querySelector(':scope > .fmh-dd-toggle');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });

    /* ---------------- Mobile drawer dropdown toggles ---------------- */
    var mobileToggles = root.querySelectorAll('.fmh-mdd-toggle');
    mobileToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = toggle.closest('.fmh-mitem');
        var isOpen = item.classList.contains('fmh-mopen');
        item.classList.toggle('fmh-mopen', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    /* ---------------- Sticky / transparent scroll state ---------------- */
    var isTransparent = root.getAttribute('data-fmh-transparent') === 'true';
    if (isTransparent) {
      var applyScrollState = function () {
        if (window.scrollY > 8) {
          root.classList.add('fmh-scrolled');
        } else {
          root.classList.remove('fmh-scrolled');
        }
      };
      applyScrollState();
      window.addEventListener('scroll', applyScrollState, { passive: true });
    }
  });
})();